import React from "react";
import MuiBox from "../MuiBox";
import { DataGrid } from "@mui/x-data-grid";

const MuiDataGrid = ({ columns, rows }) => {
  return (
    <>
      <MuiBox
        sx={{ width: "100%", height: "100%", overflow: "auto" }}
        className="no-scrollbar"
      >
        <MuiBox sx={{ minWidth: "700px", width: "full" }}>
          <DataGrid
            rows={rows}
            columns={columns}
            hideFooter
            disableRowSelectionOnClick
            disableColumnFilter
            disableColumnSelector
            sx={{
              ".MuiDataGrid-columnHeader": {
                bgcolor: "white !important",
                borderBottom: "1px solid #F1F1F1 !important",
                // borderColor:"background.gray300 !important"
              },
              ".MuiDataGrid-row": {
                borderBottom: "1px solid #F1F1F1 !important",
                // borderColor:"background.gray300 !important"
              },
              ".MuiDataGrid-cell": {
                fontSize: "14px",
                color: "text.darkgray",
                fontFamily: "Inter",
                fontWeight: 400,
              },
              ".MuiDataGrid-columnHeaderTitle": {
                fontSize: "14px", // Change size
                fontFamily: "Inter",
              },
              ".MuiDataGrid-cell:focus": {
                outline: "none",
              },
              ".MuiDataGrid-columnHeader:focus": {
                outline: "none",
              },
              ".MuiDataGrid-menuIcon": {
                display: "none",
              },
            }}
          />
        </MuiBox>
      </MuiBox>
    </>
  );
};

export default MuiDataGrid;
